<div mat-dialog-content class="material-admin-colors">
  <form class="user-form" #form="ngForm" (ngSubmit)='save()'>
    <mat-tab-group>

      <mat-tab label="Personal Information">
        <div class="row py-3">
          <div class="col-md-6 col-sm-12">
            <div class="col-12">
              <mat-form-field>
                <mat-label>Email</mat-label>
                <input matInput type="email" required placeholder="Email" #email="ngModel" name="email"
                  [(ngModel)]="user.Email" email>
                <mat-error *ngIf="email.invalid && email.hasError('required')">Email field is required</mat-error>
                <mat-error *ngIf="email.invalid && email.hasError('email')">Email field is not valid</mat-error>
              </mat-form-field>
            </div>
            <div class="row px-3">
              <div class="col-lg-6 col-md-12 col-sm-12">
                <mat-form-field>
                  <mat-label>First Name</mat-label>
                  <input matInput placeholder="First Name" name="firstname" #firstname="ngModel"
                    [(ngModel)]="user.FirstName" required minlength="1" maxlength="40">
                  <mat-error *ngIf="firstname.invalid && firstname.hasError('required')">First Name field is required
                  </mat-error>
                  <mat-error *ngIf="firstname.invalid && firstname.hasError('minlength')">First name is too short
                  </mat-error>
                  <mat-error *ngIf="firstname.invalid && firstname.hasError('maxlength')">First name is too long
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-6 col-md-12 col-sm-12">
                <mat-form-field>
                  <mat-label>Last Name</mat-label>
                  <input matInput placeholder="Last Name" name="lastname" #lastname="ngModel"
                    [(ngModel)]="user.LastName" required minlength="1" maxlength="40">
                  <mat-error *ngIf="lastname.invalid && lastname.hasError('required')">Last Name field is required
                  </mat-error>
                  <mat-error *ngIf="lastname.invalid && lastname.hasError('minlength')">Last name is too short
                  </mat-error>
                  <mat-error *ngIf="lastname.invalid && lastname.hasError('maxlength')">Last name is too long
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div *ngIf="!user.Id" class="col-12 mt-3">
              <mat-form-field>
                <mat-label>Password</mat-label>
                <input matInput placeholder="Enter the password" [type]="hidePass ? 'password' : 'text'"
                  [(ngModel)]="passwordModel" #password="ngModel" name="password" required minlength="7" maxlength="127"
                  [pattern]="passwordPattern">
                <mat-icon matTooltip="Hide/Show Password" matSuffix (click)="hidePass = !hidePass"
                  [svgIcon]="hidePass ? 'visibility_off' : 'visibility'">
                </mat-icon>
                <mat-error *ngIf="password.invalid && password.hasError('required')">Password is required</mat-error>
                <mat-error *ngIf="password.invalid && password.hasError('minlength')">Password should be from 7 to 127
                  symbols length</mat-error>
                <mat-error *ngIf="password.invalid && password.hasError('pattern')">Password required a letter and
                  digit character</mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="!user.Id" class="col-12 mt-3">
              <mat-form-field>
                <mat-label>Retype the password</mat-label>
                <input matInput placeholder="Enter the password once again" [type]="hideConfirm ? 'password' : 'text'"
                  [(ngModel)]="confirmPasswordModel" name="passwordConfirmation" #passwordConfirmation="ngModel"
                  required>
                <mat-icon matTooltip="Hide/Show Password Confirmation" matSuffix (click)="hideConfirm = !hideConfirm"
                  [svgIcon]="hideConfirm ? 'visibility_off' : 'visibility'"></mat-icon>
                <mat-error *ngIf="passwordConfirmation.invalid && passwordConfirmation.hasError('required')">Password
                  confirmation is required</mat-error>
              </mat-form-field>
              <div class="fake-mat-error" *ngIf="confirmPasswordModel && confirmPasswordModel != passwordModel">
                Password does not match confirmation</div>
            </div>
            <div class="col-12 mt-2">
              <mat-checkbox [(ngModel)]="user.ShouldPasswordExpire" name="shouldPasswordExpire"
                matTooltip="Password will expire every 60 days">Password expiration</mat-checkbox>
            </div>
            <div class="col-12 mt-3">
              <label class="standalone-label">Language</label>
              <mat-select placeholder="Language" #language="ngModel" name="language" [(ngModel)]="user.Language">
                <mat-option *ngFor="let lang of languages" value="{{lang.code}}"> {{lang.name}}</mat-option>
              </mat-select>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="col-12" *ngIf="user.Id">
              <label class="standalone-label">Security</label>
              <br>
              <button mat-raised-button class="btn" [ngClass]="{'btn-blue': !user.TwoFactorEnabled}" type="button" (click)="toggleTwoFatorAuth()">
                <mat-icon class="icon" [svgIcon]="user.TwoFactorEnabled ? 'key_off' : 'key_on'"></mat-icon>
                {{ user.TwoFactorEnabled ? 'Disable two-factor authentication' : 'Enable two-factor authentication' }}</button>
            </div>
            <div class="col-12">
              <br>
              <label [class.fake-label-error]="!user.Roles.length" class="standalone-label">Roles</label>
              <br>
              <ng-container *ngFor="let role of roles">
                <mat-checkbox (change)="onRoleChanged($event.checked, role)"
                  [checked]="user.Roles.includes(role.Name)" [disabled]="role?.Name === adminRole && !allowEditAdminRole"
                  [matTooltip]="role?.Name === adminRole && !allowEditAdminRole ? 'Create other admin before update this one!' : ''"
                  matTooltipPosition="left">{{role.Name}}</mat-checkbox>

                <mat-checkbox *ngIf="role?.Name === editorRole && user.Roles.includes(role.Name) && !user.Roles.includes(adminRole)"
                  class="rc-checkbox" name="HasAccessToRemoteControl" matTooltip="Enable/Disable Remote control feature"
                  matTooltipPosition="left" [(ngModel)]="user.HasAccessToRemoteControl">Remote control</mat-checkbox>

                <mat-checkbox *ngIf="role?.Name === categoryManagerRole && user.Roles.includes(role.Name) && !user.Roles.includes(adminRole)"
                  class="rc-checkbox" name="HasAccessToDisconnectAgents"
                  [(ngModel)]="user.HasAccessToDisconnectAgents">Allow to disconnect devices</mat-checkbox>
              </ng-container>
              <div class="fake-mat-error pt-3" *ngIf="!user.Roles.length">
                At least one role must be selected</div>
            </div>

            <div class="col-12 mt-5" *ngIf="!user.Id">
              <mat-checkbox [(ngModel)]="user.ShouldConfirmEmail" name="shouldConfirmEmail">Requires
                user confirmation</mat-checkbox>
            </div>

            <div class="col-12 d-flex" *ngIf="!user.Id">
              <mat-checkbox [(ngModel)]="user.ShouldAcceptLegalConsent" name="legalConsent"
                [disabled]="!isLegalConsentOptionAllowed">Legal consent request</mat-checkbox>
              <mat-icon class="ml-2" matTooltip="Edit legal consent text content" svgIcon="setting"
                (click)="editConsentContent()"></mat-icon>
            </div>

            <div class="col-12" *ngIf="checkIsAdminRoleChanged()">
              <mat-form-field>
                <mat-label>Current user`s password</mat-label>
                <input matInput placeholder="Enter current password" #currentPassword="ngModel" name="currentPassword"
                  [type]="hideCurrent ? 'password' : 'text'" [(ngModel)]="user.OldPassword">
                <mat-icon matTooltip="Hide/Show Current Password" matSuffix (click)="hideCurrent = !hideCurrent"
                  [svgIcon]="hideCurrent ? 'visibility_off' : 'visibility'">
                </mat-icon>
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Screens Permissions">
        <div class="row mt-3">
          <div class="col-md-12 scrollable-container">

            <div class="manage-locations-container">
              <mat-checkbox class="pl-2" disableRipple [checked]="isAllLocationsSelected()"
                matTooltip="Select all locations"
                [disabled]="!!!filteredCategories.length"
                (change)="onSelectAllLocations($event.checked)">
                  Select All
              </mat-checkbox>

              <div class="d-flex">
                <input type="text" [clickOutside]="[]" [isToChangeFocus]="true" class="filter-search" placeholder="Filter locations"
                  [(ngModel)]="filterText" [ngModelOptions]="{standalone: true}" matTooltip="Filter locations">

                <div class="sort-view ml-3 d-flex align-items-center px-2" *ngIf="categories?.length">
                  <span matTooltip="Filter by category">Category:</span>
                  <select class="sort-selector" [(ngModel)]="filterCategoryId" name="sort-select">
                    <option selected [ngValue]="null">All</option>
                    <ng-container *ngFor="let category of categories">
                      <option *ngIf="category.Id"
                        [value]="category.Id">{{ category.Name }}</option>
                    </ng-container>
                    <option disabled *ngIf="!categories?.length">There are no categories in the system</option>
                  </select>
                </div>
              </div>
            </div>

            <mat-divider class="mt-2 mb-2"></mat-divider>

            <div *ngFor="let category of categories$ | async | categoryFilter: filterText: filterCategoryId; trackBy: trackByIndex; let i = index">
              <div class="d-flex px-2 pt-2 mb-2"
                [ngStyle]="{ 'background-color': category.Color }">
                  <mat-checkbox disableRipple [checked]="isCategorySelected(category)"
                    (change)="onCategoryCheckChanged($event.checked, category)">
                      <b>{{ category.Name }}</b>
                  </mat-checkbox>
                  <span class="ml-4">{{ category?.Description }}</span>
              </div>
              <ng-container *ngFor="let location of category.Machines | locationFilter: filterText; trackBy: trackByIndex">
                <mat-checkbox class="pl-4" disableRipple *ngIf="location.isActive" [checked]="isLocationSelected(location)"
                  (change)="onMachineCheckChanged($event.checked, location, category)">
                  {{ location.Title }} ({{ location.PhysicalAddress }})</mat-checkbox>
                <ul class="pl-5" *ngIf="location.Monitors">
                  <li *ngFor="let screen of location.Monitors; trackBy: trackByIndex">
                    <mat-checkbox disableRipple [checked]="isScreenSelected(screen)"
                      (change)="onMonitorCheckChanged($event.checked, screen, category)"> {{ screen.MonitorTitle }}</mat-checkbox>
                  </li>
                </ul>
              </ng-container>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Playlists` sharing">
        <div class="row mt-3">
          <div class="col-md-12 scrollable-container pt-2">
            <div class="mb-3" *ngFor="let item of playlistsByUsersCollection">
              <div *ngIf="item?.User?.Id !== user?.Id && item.OwnedPlaylists && item.OwnedPlaylists.length" class="row">
                <div class="col-12 mb-2">
                  <h4>
                    <mat-checkbox matTooltip="Select all playlists"
                      (change)="onSelectAllPlaylistsChanged($event.checked, item)"
                      [checked]="isAllPlaylistsChecked(item)" class="playlist-shared d-inline pl-2">
                      {{item.User.FirstName}} {{item.User.LastName}}
                    </mat-checkbox>
                  </h4>
                </div>
                <div class="col-5 pl-5">
                  <div *ngFor="let playlist of item.OwnedPlaylists | playlistLocationFilter: true">
                    <mat-checkbox disableRipple (change)="onPlaylistItemChanged($event.checked, playlist, item)"
                      [checked]="isPlaylistSelected(playlist)" class="playlist-shared">
                      <span [matTooltip]="playlist.PlaylistTitle">{{playlist.PlaylistTitle}}</span>
                    </mat-checkbox>
                  </div>
                </div>
                <div class="col-7 pl-5">
                  <div *ngFor="let playlist of item.OwnedPlaylists | playlistLocationFilter">
                    <mat-checkbox disableRipple (change)="onPlaylistItemChanged($event.checked, playlist, item)"
                      [checked]="isPlaylistSelected(playlist)" class="playlist-shared"
                      [disabled]="isPlaylistCheckboxDisabled(playlist)">
                      {{playlist.PlaylistTitle}} <span *ngIf="playlist.Machine">(Location: {{ playlist.Machine?.Title }})</span>
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Tags` sharing">
        <div class="row mt-3">
          <div class="col-md-12 scrollable-container pt-2">
            <div class="mb-3" *ngFor="let item of tagsByUsersCollection">
              <div
                *ngIf="item?.User?.Id !== user?.Id && item.OwnedMonitorTags && item.OwnedMonitorTags.length"
                class="row">
                <div class="col-12 mb-2">
                  <h4>
                    <mat-checkbox matTooltip="Select all tags"
                      (change)="onSelectAllTagsChanged($event.checked, item)" [checked]="isAllMonitorTagsCheched(item)"
                      class="playlist-shared d-inline pl-2">
                      {{item.User.FirstName}} {{item.User.LastName}}
                    </mat-checkbox>
                  </h4>
                </div>
                <div class="col-5 pl-5">
                  <div *ngFor="let tag of item.OwnedMonitorTags">
                    <mat-checkbox disableRipple class="playlist-shared"
                      (change)="onMonitorTagItemChanged($event.checked, tag, item)"
                      [checked]="isMonitorTagSelected(tag)">
                      <span [matTooltip]="tag.Title">{{tag.Title}}</span>
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Change password" *ngIf="user.Id">
        <form #changePasswordForm="ngForm" (ngSubmit)='changePassword()'>
          <div class="row">
            <div class="col-11 ml-3 mt-3">Change password of user: {{ user.Email }}</div>
            <div class="col-12">
              <div class="col-12 col-lg-6 mt-2" *ngIf="user.Roles.includes(adminRole) || checkIsAdminRoleChanged()">
                <mat-form-field>
                  <mat-label>Old Password</mat-label>
                  <input matInput placeholder="Enter old password" #oldPassword="ngModel" name="oldPassword"
                    [type]="hideOldPass ? 'password' : 'text'" [(ngModel)]="changePasswordModel.OldPassword" required>
                  <mat-icon matTooltip="Hide/Show Password" matSuffix (click)="hideOldPass = !hideOldPass"
                    [svgIcon]="hideOldPass ? 'visibility_off' : 'visibility'"></mat-icon>
                  <mat-error *ngIf="oldPassword.invalid && oldPassword.hasError('required')">
                    Old password is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-12 col-lg-6 mt-2">
                <mat-form-field>
                  <mat-label>New Password</mat-label>
                  <input matInput placeholder="Enter new password" #newPassword="ngModel" name="newPassword"
                    [type]="hidePass ? 'password' : 'text'" [(ngModel)]="changePasswordModel.NewPassword" minlength="7" maxlength="127"
                    [pattern]="passwordPattern" required>
                  <mat-icon matTooltip="Hide/Show Password" matSuffix (click)="hidePass = !hidePass"
                    [svgIcon]="hidePass ? 'visibility_off' : 'visibility'"></mat-icon>
                  <mat-error *ngIf="newPassword.invalid && newPassword.hasError('required')">
                    Password is required
                  </mat-error>
                  <mat-error *ngIf="newPassword.invalid && newPassword.hasError('minlength')">Password should be from 7 to 127
                    symbols length
                  </mat-error>
                  <mat-error *ngIf="newPassword.invalid && newPassword.hasError('pattern')">Password required a letter
                    and
                    digit character
                  </mat-error>
                </mat-form-field>
                <div class="fake-mat-error mt-0"
                  *ngIf="isPasswordExpired && newPassword.valid && changePasswordModel.OldPassword === changePasswordModel.NewPassword">New
                    password should not match old password</div>
              </div>

              <div class="col-12 col-lg-6 mt-3">
                <mat-form-field>
                  <mat-label>Retype password</mat-label>
                  <input matInput placeholder="Enter password once again" #confirmPassword="ngModel"
                    name="confirmPassword" [type]="hideConfirm ? 'password' : 'text'" [(ngModel)]="changePasswordModel.ConfirmPassword"
                    required>
                  <mat-icon matTooltip="Hide/Show Password Confirmation" matSuffix (click)="hideConfirm = !hideConfirm"
                    [svgIcon]="hideConfirm ? 'visibility_off' : 'visibility'">
                  </mat-icon>
                  <mat-error *ngIf="confirmPassword.invalid && confirmPassword.hasError('required')">
                    Password confirmation is required
                  </mat-error>
                </mat-form-field>
                <div class="fake-mat-error mt-0" *ngIf="changePasswordModel.ConfirmPassword != changePasswordModel.NewPassword">Password
                  does not match confirmation</div>
              </div>
              <button mat-raised-button class="btn-green px-2 py-1 ml-3"
                [disabled]="changePasswordForm.pristine || changePasswordForm.invalid || changePasswordModel.NewPassword != changePasswordModel.ConfirmPassword ||
                 isPasswordExpired && changePasswordModel.OldPassword === changePasswordModel.NewPassword"
                #submit type="submit">Change password</button>
            </div>
          </div>
        </form>
      </mat-tab>

      <mat-tab label="User API Tokens" *ngIf="user.Id">
        <div class="row mt-3">
          <div class="col-md-12 scrollable-container">
            <button mat-raised-button type="button" class="btn btn-blue" (click)="createUserApiToken()">
              Create API Token</button>

            <mat-table #table [dataSource]="dataSource" class="mt-3">
              <ng-container matColumnDef="Name">
                <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
                <mat-cell *matCellDef="let token">{{ token.Name }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="DateRegistered">
                <mat-header-cell *matHeaderCellDef>Created on</mat-header-cell>
                <mat-cell *matCellDef="let token">{{ token.DateCreated | date : 'shortDate' }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                <mat-cell *matCellDef="let token">
                  <div class="action">
                    <span class="btn pl-0" (click)="revokeToken(token.Id)">Revoke</span>
                  </div>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

              <tr class="mat-row d-flex" *matNoDataRow>
                <td class="mat-cell w-100 d-flex align-items-center justify-content-center">There are no API Tokens in the system</td>
              </tr>
            </mat-table>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

    <div class="row modal-bottom-area">
      <div class="col-12">
        <hr class="my-3">
        <div class="d-flex justify-content-between">
          <button mat-raised-button class="btn-green" [disabled]="form.pristine || form.invalid || !user.Roles.length || saveInProgress ||
            confirmPasswordModel != passwordModel || user.NewPassword != user.ConfirmPassword || (checkIsAdminRoleChanged() && !user.OldPassword)"
            #submit type="submit">
              @if (saveInProgress) {
                <mat-spinner class="save-spinner" [diameter]="17"></mat-spinner>
              }
              @else { Save }
          </button>
          <button type="button" mat-raised-button (click)="close()" class="no-click">
            Close
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
